import "./UserDataTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Barcode from "react-barcode";
import { QRCodeSVG } from "qrcode.react";
import newRequest from "../../../../utils/userRequest";
import backendUrl from "../../../../utils/backendUrl";
import CustomSnakebar from "../../../../utils/CustomSnakebar";
import { MuiCustomTable } from "../../../../utils/MuiCustomTable";
import ActionDropdown from "../../../../utils/ActionDropdown"; // Import ActionDropdown
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import americanLogo from "../../../../images/HD GST LOGO.png";

const UserDataTable = ({
  columnsName,
  data,
  title,
  actionColumnVisibility,
  loading,
  backButton,
  UniqueId,
  handleApiCall,
  deleteBtnEndPoint,
  secondaryColor,
  globalSearch = false,
}) => {
  const navigate = useNavigate();
  const [record, setRecord] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [qrcodeValue, setQRCodeValue] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [companyLogo, setLogo] = useState(americanLogo);
  const [message, setMessage] = useState(null);
  const [severity, setSeverity] = useState(null);
  const [error, setError] = useState(null);
  const [muiFilteredData, setMuiFilteredData] = useState([]);
  const [shipmentIdSearch, setShipmentIdSearch] = useState("");
  const [containerIdSearch, setContainerIdSearch] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  // Retrieve the value with the key "myKey" from localStorage getvalue
  const myValue = localStorage.getItem("userId");

  const handleDelete = async (id, rowdata) => {
    let success = false;
    switch (UniqueId) {
      case "assetPrintingId":
        data = { TagNumber: rowdata.TagNumber };
        newRequest
          .delete(deleteBtnEndPoint, { data })
          .then((response) => {
            setMessage(response?.data?.message ?? "User deleted successfully");
            setSeverity("success");
            success = true;
          })
          .catch((error) => {
            setMessage(error?.message ?? "Something went wrong");
            setSeverity("error");
            console.error(error);
            success = false;
          });

        break;
      case "verifiedAssetId":
        data = { TagNumber: rowdata.TagNumber };
        newRequest
          .delete(deleteBtnEndPoint, { data })
          .then((response) => {
            setMessage(response?.data?.message ?? "User deleted successfully");
            setSeverity("success");
            success = true;
          })
          .catch((error) => {
            setMessage(error?.message ?? "Something went wrong");
            setSeverity("error");
            console.error(error);
            success = false;
          });

        break;

      default:
        // do nothing
        break;
    }

    if (success) {
      setRecord(record.filter((item) => item.id !== id));
      // alert("User deleted successfully");
    }
  };
  const handleEdit = async (rowData) => {
    // For asset printing & verified assets, reuse the asset detail page
    if (UniqueId === "assetPrintingId" || UniqueId === "verifiedAssetId") {
      sessionStorage.setItem("viewRowData", JSON.stringify(rowData));
      sessionStorage.setItem("viewMode", "edit");
      navigate(`/member/view-verifiedasset/${rowData.id}`);
      return;
    }
    // For other tables, extend this switch as needed
  };

  const handleView = (rowData) => {
    // console.log("Viewing row data:", rowData);
    navigate(`/member/view-verifiedasset/${rowData.id}`);
    sessionStorage.setItem("viewRowData", JSON.stringify(rowData));
  };

  useEffect(() => {
    // newRequest.get("/GetLogoImage").then((response) => {
    //   console.log(response?.data);
    //   let logoVariable = response?.data[0].logo;
    //   const liveURL = backendUrl + "/" + logoVariable.replace(/\\/g, "/");
    //   setLogo(liveURL);
    //   console.log(response?.data[0].logo);
    //   console.log(liveURL);
    // });

    if (data) {
      setRecord(data.map((item, index) => ({ ...item, id: index + 1 })));
    }
  }, [data]);


  const filteredData =
    shipmentIdSearch && containerIdSearch
      ? record.filter(
        (item) =>
          item.SHIPMENTID.toLowerCase().includes(
            shipmentIdSearch.toLowerCase()
          ) &&
          item.CONTAINERID.toLowerCase().includes(
            containerIdSearch.toLowerCase()
          )
      )
      : shipmentIdSearch && !containerIdSearch
        ? record.filter((item) =>
          item.SHIPMENTID.toLowerCase().includes(shipmentIdSearch.toLowerCase())
        )
        : !shipmentIdSearch && containerIdSearch
          ? record.filter((item) =>
            item.CONTAINERID.toLowerCase().includes(
              containerIdSearch.toLowerCase()
            )
          )
          : record;

  useEffect(() => {
    setMuiFilteredData(filteredData);
  }, [filteredData]);


  const handleSearch = (e) => {
    // setShipmentIdSearch(e.target.value);
    e.target.name === "SHIPMENTID"
      ? setShipmentIdSearch(e.target.value)
      : setContainerIdSearch(e.target.value);
    // console.log(e.target.name, e.target.value);
    // console.log(shipmentIdSearch, containerIdSearch);
  };

  const handleGlobalSearch = (e) => {
    // when user search what ever he types filter the data and show it in the table
    const searchValue = e.target.value;
    // console.log(searchValue);
    // const filteredData = record.filter((item) => {
    //   // check if the search value is in any of the object values
    //   return Object.values(item).some((value) =>
    //     value.toString().toLowerCase().includes(searchValue.toLowerCase())
    //   );
    // });
    const filteredData = record.filter((item) => {
      return Object.values(item).some((value) =>
        value && value.toString().toLowerCase().includes(searchValue.toLowerCase())
      );
    });

    // console.log(filteredData);
    setMuiFilteredData(filteredData);


  };

const handlePrint = () => {
  // Require at least one selected row
  const labelRoot = document.getElementById("print-label-root");
  if (!labelRoot) {
    alert("Please select at least one asset row to print.");
    return;
  }

  const labelsHtml = labelRoot.innerHTML;

  const printWindow = window.open("", "Print Window", "height=600,width=900");

  const html =
    "<html><head><title>Asset Tag</title>" +
    "<style>" +
    "@page { size: 3.5in 2in; margin: 0; }" +
    "body { margin: 0; font-family: Arial, sans-serif; }" +
    ".print-label { box-sizing: border-box; width: 100%; padding: 8px 10px; }" +
    ".label-header { display: flex; justify-content: space-between; align-items: flex-start; }" +
    ".label-logo { max-width: 80%; max-height: 60px; height: auto; }" +
    ".label-qr { width: 64px; height: 64px; }" +
    ".label-divider { margin: 4px 0 6px; border-top: 1px solid #000; }" +
    ".label-barcode-wrapper { display: flex; justify-content: center; margin: 0 0 6px; }" +
    ".label-tag { text-align: center; font-size: 11px; font-weight: 600; }" +
    ".label-description { text-align: center; font-size: 11px; }" +
    "</style>" +
    "</head><body>" +
    labelsHtml +
    "</body></html>";

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};

  const handleSelectionChange = (newSelection) => {
    setSelectedIds(newSelection);

    const selectedRows = newSelection
      .map((id) => muiFilteredData.find((row) => row.id === id))
      .filter(Boolean);

    setSelectedRow(
      selectedRows.map((row) => ({
        data: row,
        index: row.id,
      }))
    );
  };

  // Remove the selected row when it is unselected
  //  const handleSelectionChange = (selection) => {
  //   if (selection.length === 0) {
  //     setSelectedRow([]);
  //   }
  // };
  const CustomCell = (params) => {
    const style = {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "auto",
      minWidth: 0, // add this property
      maxWidth: "100%", // add this property
    };
    return <div style={{ ...style, overflowX: "auto" }}>{params.value}</div>;
  };
  const columnsWithCustomCell = columnsName.map((column) => {
    if (column.width) {
      return {
        ...column,
        renderCell: CustomCell,
      };
    }
    return column;
  });

  // const actionColumn = [
  //   {
  //     field: "action",
  //     headerName: "Action",
  //     width: 220,
  //     renderCell: (params) => {
  //       return (
  //         <div className="cellAction">
  //           <div
  //             className="deleteButton"
  //             onClick={() => handleDelete(params.row.id, params.row)}
  //           >
  //             Delete
  //           </div>
  //           <span
  //             onClick={() => handleEdit(params.row)}
  //             style={{ textDecoration: "none" }}
  //           >
  //             <div className="editButton">Update</div>
  //           </span>
  //           <span
  //             onClick={() => handleView(params.row)}
  //             style={{ textDecoration: "none" }}
  //           >
  //             <div className="viewButton">View</div>
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  // const idColumn = [
  //   {
  //     field: "id",
  //     headerName: "ID",
  //     width: 30,
  //   },
  // ];
  

  // Define dropDownOptions for the ActionDropdown
  const dropDownOptions = [
    {
      label: "View",
      action: handleView,
      icon: (
        <VisibilityIcon
          fontSize="small"
          color="action"
          style={{ color: "rgb(37 99 235)" }}
        />
      ),
    },
    {
      label: "Edit",
      action: handleEdit,
      icon: (
        <EditIcon
          fontSize="small"
          color="action"
          style={{ color: "rgb(37 99 235)" }}
        />
      ),
    },
    {
      label: "Delete",
      action: (row) => handleDelete(row.id, row),
      icon: <DeleteIcon fontSize="small" style={{ color: "#FF0032" }} />,
    },
  ];

  // Define the actionColumn using ActionDropdown
  const actionColumn = [
    {
      field: "action",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <ActionDropdown
          row={params.row}
          dropDownOptions={dropDownOptions}
        />
      ),
    },
  ];

  // Define idColumn
  const idColumn = [
    {
      field: "id",
      headerName: "ID",
      width: 30,
    },
  ];
  

  return (
    <>
      {message && (
        <CustomSnakebar
          message={message}
          severity="success"
          onClose={resetSnakeBarMessages}
        />
      )}
      {error && (
        <CustomSnakebar
          message={error}
          severity="error"
          onClose={resetSnakeBarMessages}
        />
      )}

      <div className="datatable">
        <div className="datatableTitle">
          {title}
          
          {/* if global search is true than show search bar instead of title */}
          <div className="sm:w-[45%] w-full">
            {globalSearch &&
              <span>
                <input
                  type="text"
                  placeholder={'SEARCH'}
                  name="SHIPMENTID"
                  className="border-[1px] rounded-md border-secondary w-full p-1 text-lg"
                  onChange={handleGlobalSearch}
                  />
              </span>
            }
          </div>
          
          <span className="leftDatatableTitle">
            {backButton && (
              <button
                onClick={() => {
                  navigate(-1);
                }}
              >
                Go Back
              </button>
            )}
            {/* <button onClick={handlePrint}>Print Asset</button> */}
            {UniqueId === "GenerateTagsId" ? (
              <button onClick={handleApiCall}>GenerateTags</button>
            ) : (
              <button onClick={handlePrint}>Print Asset</button>
            )}
          </span>

        </div>

        <MuiCustomTable
          getRowHeight={({}) => {
            let x;
            title === "USER ACCOUNTS" ? (x = 100) : (x = 60);
            return x;
          }}
          secondaryColor={secondaryColor ? secondaryColor : null}
          loading={loading}
          className="datagrid"
          rows={muiFilteredData}
          // columns={
          //   actionColumnVisibility !== false
          //     ? idColumn.concat(columnsWithCustomCell.concat(actionColumn))
          //     : idColumn.concat(columnsWithCustomCell)
          // }
          columns={
            actionColumnVisibility !== false
              ? actionColumn.concat(idColumn.concat(columnsWithCustomCell)) // Action column first
              : idColumn.concat(columnsWithCustomCell)
          }
          // pageSiz b={30}
          pageSizeOptions={[50, 100, { value: -1, label: "All" }]}
          pagination
          checkboxSelection
          selectionModel={selectedIds}
          onSelectionModelChange={handleSelectionChange}
        />

        {/* Displaying myValue inside the table Value in center*/}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "-40px",
            marginLeft: "10px",
          }}
        >
          <h1 style={{ whiteSpace: "nowrap" }}>UserId: {myValue}</h1>
          <style>
            {`
            @media (max-width: 480px) {
              h1 {
                display: none;
              }
            }
            `}
          </style>
        </div>

        {/* Prepared labels for printing (hidden in the main UI) */}
        {selectedRow.length > 0 && (
          <div id="print-label-root" className="hidden">
            {selectedRow.map((selectedRow, index) => (
              <div className="print-label" key={index}>
                <div className="label-header">
                  <img
                    className="label-logo"
                    src={companyLogo}
                    alt="Company logo"
                  />
                  <QRCodeSVG
                    className="label-qr"
                    value={`${selectedRow.data.TagNumber}`}
                    height={64}
                    width={64}
                  />
                </div>
                <div className="label-divider" />
                <div className="label-barcode-wrapper">
                  <Barcode
                    value={selectedRow.data.TagNumber}
                    height={40}
                    width={2.0}
                    margin={0}
                    fontSize={12}
                    displayValue={false}
                  />
                </div>
                <div className="label-tag">{selectedRow.data.TagNumber}</div>
                <div className="label-description">
                  {selectedRow.data.aSSETdESCRIPTION ||
                    selectedRow.data.MinorCategoryDescription}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default UserDataTable;







